import { render, staticRenderFns } from "./taskflowList.vue?vue&type=template&id=0c3fa33e&scoped=true"
import script from "./taskflowList.vue?vue&type=script&lang=js"
export * from "./taskflowList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3fa33e",
  null
  
)

export default component.exports